
import { InputGroup, DropdownButton, Dropdown, Form, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function SearchBar(props){
  // text search bar, includes input field, dropdown to filter searches by category, and a search button

    const navigate = useNavigate();
    const categories = useSelector((state) => state.categories);

    const [searchCategory, setSearchCategory] = useState("");
    const [searchText, setSearchText] = useState("");

    const handleSearchClick = () => {
        let url = `/product-list`;
        if (searchCategory) {
          const categoryId = searchCategory.split(",")[1];
          url = `${url}/category/${categoryId}`;
        }
        if (searchText) {
          url = `${url}?searchText=${searchText}`;
        }
        setSearchCategory("");
        setSearchText("");
        navigate(url);
      };
      

    return (
    <InputGroup className={`search-bar-button ${props?.smallScreen ? "search-bar-sm-screen" : "search-bar-lg-screen"}`} 
>
    <DropdownButton
      variant="none"
      id="dropdown-basic-button"
      title={searchCategory.split(",")[0] || "All"}
      onSelect={(eventKey) => setSearchCategory(eventKey)}
      
 
    >
      <Dropdown.Item default key={0} eventKey={""}  >
        {"All"}
      </Dropdown.Item>
      {categories && categories.map((category, idx) => {
        return (
          <Dropdown.Item
            key={category?._id}
            eventKey={`${category?.name},${category?._id}`}
            
          >
            {category?.name}
          </Dropdown.Item>
        );
      })}
    </DropdownButton>
    <Form.Control
      type="text"
      placeholder="Search Shop"
      onChange={(event) => setSearchText(event.target.value)}
      value={searchText}
      onKeyUp={(event) => {
        if(event.key === "Enter"){
          handleSearchClick(); 
        }
      }}
    />
    <Button variant="none" onClick={() => {
        handleSearchClick(); 
        if(props.toggleNavExpansion){
          props?.toggleNavExpansion()}
        }}>
      <i className="bi bi-search"></i>
    </Button>
  </InputGroup>
    )
}